import type { UserRegistrationInfo } from '@/views/AccountInfoRegister/const';
import http from '../http';
import type { TransAccountInfo } from '@/views/TransAccountInfo/const';


export const updateUserInfo = async (userData: UserRegistrationInfo) => {
  return await http.put('/users',userData)
}

export const updateUserInfoForTrans = async (userData: TransAccountInfo) => {
  return await http.put('trans/users',userData)
}


export const getAllUsers = (keyWord: string) => {
  return http.get('/admin/users',{
    params: { keyWord }
  });
};

export const getUserDetailInfo = async () => {
    return await http.get('users/info');
}

export const getUserDetailInfoForTrans = async () => {
  return await http.get('trans/users/info');
}

export const getUserInfoByAdmin = async (userId:number) => {
  return await http.get(`admin/users/${userId}`);
}

export const updateUserInfoByAdmin = async (userData: UserRegistrationInfo, userId: number) => {
  return await http.put(`admin/users/${userId}`, userData);
}

export const registerUserInfo = async (userData: UserRegistrationInfo,userId:number) => {
  return await http.put(`/users/${userId}`, userData, { noToken: true })
}

export const deleteUser = async (userId: number) => {
  return await http.delete(`admin/users/${userId}`);
}

export const getUserByEmailToken = async (emailToken: string) => {
  return await http.get('users/email-token',{
    params: { emailToken }, noToken: true
  },);
}

export const checkKeyRegistered = async (subNumOrEdiKey: string, userId: number) => {
  const res = await http.get(`users/${userId}/check-key-registered`, {
    params: {
      subNumOrEdiKey: subNumOrEdiKey
    }
  }) as any;
  return res.result as boolean;
}






